/**
 * Delay in millisecond to set loading to false after closing the invite dialogs
 * This is to ensure that the dialog closes before resetting the loading state
 * and to prevent duplicate invitation request.
 */
export const INVITE_DIALOG_CLOSE_DELAY_MS = 300;